import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const UkFlag = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 6.49785V8.92308H4.43933L1 6.49785ZM3.85022 20H8.94444V16.408L3.85022 20ZM15.0556 16.4086V20H20.1492L15.0556 16.4086ZM1 15.0769V17.5022L4.44056 15.0769H1ZM20.1504 4H15.0556V7.592L20.1504 4ZM23 17.5028V15.0769H19.5588L23 17.5028ZM23 8.92308V6.49785L19.5601 8.92308H23ZM8.94444 4H3.85022L8.94444 7.592V4Z"
        fill="#00247D"
      />
      <path
        d="M16.3633 15.0769L22.2984 19.2622C22.5878 18.9611 22.796 18.5906 22.9034 18.1858L18.4943 15.0769H16.3633ZM8.94444 15.0769H7.63606L1.70156 19.2615C2.01994 19.5877 2.42817 19.8209 2.88589 19.9292L8.94444 15.6572V15.0769ZM15.0556 8.92308H16.3639L22.2984 4.73846C21.9743 4.40788 21.564 4.1764 21.1147 4.07077L15.0556 8.34277V8.92308ZM7.63606 8.92308L1.70156 4.73846C1.41199 5.03947 1.20354 5.40994 1.09594 5.81477L5.50511 8.92308H7.63606Z"
        fill="#CF1B2B"
      />
      <path
        d="M23 13.8462H13.8333V20H15.0556V16.4086L20.1492 20H20.5556C20.8802 19.9997 21.2015 19.9343 21.5007 19.8076C21.7999 19.6809 22.0711 19.4955 22.2984 19.2622L16.3633 15.0769H18.4943L22.9034 18.1858C22.9603 17.9785 23 17.7637 23 17.5385V17.5028L19.5588 15.0769H23V13.8462ZM1 13.8462V15.0769H4.44056L1 17.5022V17.5385C1 18.2098 1.26828 18.8172 1.70156 19.2615L7.63606 15.0769H8.94444V15.6572L2.88589 19.9292C3.06556 19.9723 3.25133 20 3.44444 20H3.85022L8.94444 16.408V20H10.1667V13.8462H1ZM23 6.46154C23.0006 5.81657 22.7485 5.1974 22.2984 4.73846L16.3639 8.92308H15.0556V8.34277L21.1147 4.07077C20.9317 4.02555 20.744 4.0018 20.5556 4H20.1504L15.0556 7.592V4H13.8333V10.1538H23V8.92308H19.5601L23 6.49785V6.46154ZM8.94444 4V7.592L3.85022 4H3.44444C3.11979 4.00037 2.79846 4.06587 2.49922 4.19266C2.19998 4.31945 1.92881 4.50499 1.70156 4.73846L7.63606 8.92308H5.50511L1.09594 5.81477C1.03554 6.0251 1.00327 6.24261 1 6.46154V6.49785L4.43933 8.92308H1V10.1538H10.1667V4H8.94444Z"
        fill="#EEEEEE"
      />
      <path
        d="M13.8333 10.1538V4H10.1667V10.1538H1V13.8462H10.1667V20H13.8333V13.8462H23V10.1538H13.8333Z"
        fill="#CF1B2B"
      />
    </svg>
  )
}
